'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash.endswith');

var _lodash2 = _interopRequireDefault(_lodash);

var _seekClassificationsHierarchy = require('@seek/seek-classifications-hierarchy');

var _worktypes = require('./worktypes');

var _worktypes2 = _interopRequireDefault(_worktypes);

var _states = require('./states');

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTargetValue = function getTargetValue(value) {
  return value.replace(/[^a-z\d]/ig, '').toLowerCase();
};

var splitTargetValues = function splitTargetValues(values, token) {
  return values.split(token).map(function (value) {
    return getTargetValue(value);
  });
};

exports.default = function (_ref, _ref2) {
  var classification = _ref.classification,
      subclassification = _ref.subclassification,
      keywords = _ref.keywords,
      worktype = _ref.worktype,
      salarytype = _ref.salarytype,
      salaryrange = _ref.salaryrange,
      advertiserid = _ref.advertiserid,
      companyid = _ref.companyid,
      graduatesearch = _ref.graduatesearch;
  var areaDescription = _ref2.areaDescription,
      locationDescription = _ref2.locationDescription,
      stateDescription = _ref2.stateDescription,
      locationType = _ref2.type,
      suburbDescription = _ref2.description;

  var targeting = [];

  if (keywords) {
    targeting.push({ key: 'kw', value: getTargetValue(keywords) });
  }

  if (classification) {
    var industries = classification.split(',').map(function (cId) {
      var classificationDesc = (0, _seekClassificationsHierarchy.classificationById)(cId);

      return getTargetValue(classificationDesc);
    });

    targeting.push({ key: 'ind', value: industries });
  }

  if (subclassification) {
    var occupations = subclassification.split(',').map(function (sId) {
      var subClassificationDesc = (0, _seekClassificationsHierarchy.subClassificationById)(sId);

      return getTargetValue(subClassificationDesc);
    });

    targeting.push({ key: 'occ', value: occupations });
  }

  if (worktype) {
    var worktypeValues = worktype.split(',').map(function (wId) {
      return _worktypes2.default[wId];
    });

    targeting.push({ key: 'wt', value: worktypeValues });
  }

  if (salaryrange) {
    var salaryKey = salarytype === 'hourly' ? 'HourlySal' : 'AnnualSal';

    targeting.push({ key: salaryKey, value: splitTargetValues(salaryrange, '-') });
  }

  if (advertiserid) {
    targeting.push({ key: 'advertiser', value: splitTargetValues(advertiserid, ',') });
  }

  if (companyid) {
    targeting.push({ key: 'company', value: splitTargetValues(companyid, ',') });
  }

  if (stateDescription) {
    targeting.push({ key: 'sta', value: _states2.default[stateDescription] });
  }

  if (locationDescription) {
    targeting.push({ key: 'loc', value: getTargetValue(locationDescription) });
  }

  if (areaDescription) {
    targeting.push({ key: 'area', value: getTargetValue(areaDescription) });
  }

  if (locationType === 'Suburb') {
    var suburbName = suburbDescription;

    if ((0, _lodash2.default)(suburbDescription, ' AU') || (0, _lodash2.default)(suburbDescription, ' NZ')) {
      suburbName = suburbDescription.slice(0, -3);
    }

    targeting.push({ key: 'suburb', value: getTargetValue(suburbName) });
  }

  if (graduatesearch) {
    targeting.push({ key: 'grad', value: 'true' });
  }

  return targeting;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-react-gpt/build/targeting/search.js
 ** module id = 835
 ** module chunks = 0
 **/